import React from 'react';

export default function Head() {
  return (
    <section>
      <h1 className="mb-3">Add New Members: Fill out the Form</h1>

      <p>
        To create a list of members, you have the option to add multiple members
        and then upload them all into the system.
      </p>
    </section>
  );
}
